var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.breadcrumbs}}),_c('heading',[_vm._v(_vm._s(_vm.year))]),_c('reportQuickActions',{attrs:{"feature":"medkitlog"}}),_c('dateFolderTable',{attrs:{"rows":_vm.rows,"loading":_vm.loading,"nameLabel":_vm.$t('folders.month')},on:{"open":_vm.openMonth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }